import Table from "../Plugin/table.vue";
// import imgOn from "../../../assets/images/on.png"
import imgOn from "../../../assets/images/onIcon.png"
import linegraph from "../../../components/linegraph.vue"
import * as echarts from "echarts"
import moment from "moment-timezone";
import { getCurrentTimezone } from '../../../utils/timezoneHelper';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-cn';
import screenfull from "screenfull";

export default {
  name: "test",
  components: { Table, linegraph },
  data() {
    return {
      carOption: {},
      carLoading: false,
      isValue: true,
      carCount: '',
      onlineCount: '',
      problemCount: '',
      problemCountId: '',
      workTimeSum: '',
      carExpirationCount: '',
      carExpirationId: '',
      alarmCount: '',
      alarmCountId: '',
      batteryChargeCount: '',
      batteryChargeCountId: '',
      batteryFreeCount: '',
      batteryFreeCountId: '',
      batteryWorkCount: '',
      batteryWorkCountId: '',
      nearExpirationCount: '',
      nearExpirationId: '',
      overExpirationCount: '',
      overExpirationId: '',
      driverExpirationCount: '',
      alarm: {
        collisionCount: '',
        outPositionCount: '',
        speedOverCount: '',
        leaveFenceCount: '',
        overLoadCount: ''
      },
      problem: {
        FilterPluggingCount: '',
        LowOilPressureCount: '',
        LowPowerCount: '',
        LowLiquidLevelCount: '',
      },
      carOptions: [],
      height: '340px',
      list: [

      ],
      option: {
        stripe: false,
        border: false,
        loading: false,
        highlightCurrentRow: false,
        serialNumber: true,
      },
      columns: [
        {
          prop: "carId",
          label: this.$t('common.carId'),
          align: "center",
          width: "210",
          render: (h, params) => {
            return h('el-tag', {
              on: {
                click: () => {
                  this.cellClick(params)
                }
              }
            }, params.row.carId)
          }
        },
        {
          prop: "workTime",
          label: this.$t('DriverAnalysis.workHour'),
          align: "center",
          width: "120"
        }
      ],
      driveList: [
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
        {
          carId: '123456',
          plateNum: '10'
        },
      ],
      driveColumns: [
        {
          prop: "name",
          label: this.$t('common.driverName'),
          align: "center",
          width: "210",
          render: (h, params) => {
            return h('el-tag', {
              on: {
                click: () => {
                  this.driverClick(params)
                }
              }
            }, params.row.name)
          }
        },
        {
          prop: "workTime",
          label: this.$t('DriverAnalysis.workHour'),
          align: "center",
          width: "120"
        },
      ],
      map: null,
      isShow: true,
      dayLoading: false,
      dayOption: {},

      weather: {},
      date: '',
      week: '',
      weekday: '',
      time: '',
      iFullScreen: false,

      longitude: '',
      latitude: '',

      view: '',
      mapZoom: '',
      centerPoint: '',
    };
  },

  created() {
    this.imgLogo = sessionStorage.getItem("logo");
    this.getData()
    this.getDataCount()
    this.getAlarmCount()
    this.getProblemCount()
    this.getCarWorkTime()
    this.getDriverWorkTime()
    this.carAndWeightHis()
    this.DayUseRate()
  },
  mounted() {
    let _this = this;
    this.timer = setInterval(() => {
      const timezone = getCurrentTimezone();
      _this.date = moment().tz(timezone).format("YYYY年MM月DD日");
      _this.time = moment().tz(timezone).format("HH:mm:ss");
    }, 100)
    const timezone = getCurrentTimezone();
    this.week = moment().tz(timezone).format('dddd')
    this.getWeather()
  },
  destroyed() {
    this.map = null
    this.isShow = false
  },
  methods: {
    getLocation() {
      return new Promise((resolve, reject) => {
        var geolocation1 = new window.BMapGL.Geolocation();
        geolocation1.getCurrentPosition(function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var mk = new window.BMapGL.Marker(r.point);
            resolve({ longitude: r.point.lng, latitude: r.point.lat })
          } else {

          }
        })
      });
    },
    async getWeather() {
      const data = await this.getLocation()
      console.log(data)
      let param = {
        longitude: data.longitude,
        latitude: data.latitude
      }
      this.$store.dispatch('HomePage/GET_SELECTUSERLOCATION', param).then(res => {
        if (res) {
          this.weather = res.data.data
        }
      }).catch(err => { })
    },
    toggleFullScreen() {
      if (screenfull.isEnabled) {
        if (!screenfull.isFullscreen) {
          this.iFullScreen = !this.iFullScreen;
          screenfull.request();
        } else {
          this.iFullScreen = !this.iFullScreen;
          screenfull.exit();
        }
      } else {
        this.$message({ message: this.$t('HomPage.form.yourBrowserDoesNotSupportFullScreen'), type: "warning" });
      }
    },

    btnEnter() {
      this.$router.push('/VehicleManagement/VehicleFiles')
    },
    btnCount() {
      this.$router.push({ name: 'VehicleAnnualReview', params: { carExpirationId: String(this.carExpirationId) } })
    },
    btnFail() {
      this.$router.push({ name: 'VehicleStatus', params: { problemCountId: this.problemCountId } })
    },
    btnViola() {
    },
    btnCharge() {
      this.$router.push({ name: 'BatteryStatus', params: { batteryId: String(this.batteryChargeCountId) } })
    },
    btnWork() {
      this.$router.push({ name: 'BatteryStatus', params: { batteryId: String(this.batteryWorkCountId) } })
    },
    btnFree() {
      this.$router.push({ name: 'BatteryStatus', params: { batteryId: String(this.batteryFreeCountId) } })
    },
    btnNear() {
      this.$router.push({ name: 'MaintenanceManagement', params: { ExpirationId: String(this.nearExpirationId) } })
    },
    btnOver() {
      this.$router.push({ name: 'MaintenanceManagement', params: { ExpirationId: String(this.overExpirationId) } })
    },
    btnExpiration() {
      this.$router.push({ name: 'DriverAnnualReview', params: { driverExpirationId: String(this.driverExpirationId) } })
    },
    carAndWeightHis(carCount, onlineCount, offLineCount) {
      const chartData = [
        {
          value: onlineCount,
          name: this.$t('HomPage.onlineCount'),
        },
        {
          value: offLineCount,
          name: this.$t('HomPage.offLineCount'),
        }
      ];
      const colorList = [
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#15cbdb',
          },
          {
            offset: 1,
            color: '#157ede',
          },
        ]),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#ff8f8f',
          },
          {
            offset: 1,
            color: '#ff5454',
          },
        ])
      ];
      const sum = chartData.reduce((per, cur) => per + cur.value, 0);
      const gap = (1 * sum) / 100;
      const pieData1 = [];
      const gapData = {
        name: '',
        value: gap,
        itemStyle: {
          color: 'transparent',
        },
      };
      for (let i = 0; i < chartData.length; i++) {
        pieData1.push({
          ...chartData[i],
          itemStyle: {
            borderRadius: 100,
            borderColor: '#2a2a34',
            borderWidth: 2,
          },
        });
        pieData1.push(gapData);
      }

      let option = {
        title: [{
          text: carCount,
          x: '24%',
          y: '37%',
          textAlign: 'center',
          textStyle: {
            fontSize: '20',
            fontWeight: '500',
            color: '#29EEF3',
            textAlign: 'center',
          },
        }, {
          text: this.$t('HomPage.carTotal'),
          left: '24%',
          top: '55%',
          textAlign: 'center',
          textStyle: {
            fontSize: '10',
            fontWeight: '400',
            color: '#fff',
            textAlign: 'center',
          },
        },],
        legend: {
          right: '20%',
          top: '25%',
          align: 'left',
          itemGap: 18,
          itemWidth: 40,
          itemHeight: 5,
          textStyle: {
            color: '#fff',
            rich: {
              name: {
                verticalAlign: 'left',
                align: 'right',
                fontSize: 14,
                color: '#fff',
              },
              percent: {
                padding: [0, 0, 0, 10],
                color: '#fff',
                fontSize: 14,
              },
            },
          },
          formatter: (name) => {
            const item = chartData.find((i) => {
              return i.name === name;
            });
            const p = item.value;
            return '{name|' + name + '}' + '{percent|' + p + '}' + this.$t('HomPage.forklift');
          },
        },

        color: colorList,

        series: [
          {
            type: 'pie',
            z: 5,
            roundCap: true,
            radius: ['60%', '70%'],
            center: ['25%', '50%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: pieData1,
          },
        ],
      };
      this.carOption = option;
    },

    driverClick(item) {
      this.$router.push({ name: "DriverStatus", params: { driverNum: item.row.driverNum, name: item.row.name } })
    },
    cellClick(val) {
      this.$router.push({ name: "VehicleStatus", params: { carId: val.row.carId } })
    },

    getDataCount() {
      let carCount = ''
      let onlineCount = ''
      let offLineCount = ''
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomePage/GET_QUERYCARDATACOUNT', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            carCount = res.data.data.carCount
            onlineCount = res.data.data.onlineCount
            offLineCount = res.data.data.offLineCount
            this.problemCount = res.data.data.problemCount
            this.problemCountId = res.data.data.problemCountId
            this.workTimeSum = res.data.data.workTimeSum
            this.carExpirationCount = res.data.data.carExpirationCount
            this.carExpirationId = res.data.data.carExpirationId
            this.alarmCount = res.data.data.alarmCount
            this.alarmCountId = res.data.data.alarmCountId
            this.batteryChargeCount = res.data.data.batteryChargeCount
            this.batteryChargeCountId = res.data.data.batteryChargeCountId
            this.batteryFreeCount = res.data.data.batteryFreeCount
            this.batteryFreeCountId = res.data.data.batteryFreeCountId
            this.batteryWorkCount = res.data.data.batteryWorkCount
            this.batteryWorkCountId = res.data.data.batteryWorkCountId
            this.nearExpirationCount = res.data.data.nearExpirationCount
            this.nearExpirationId = res.data.data.nearExpirationId
            this.overExpirationCount = res.data.data.overExpirationCount
            this.overExpirationId = res.data.data.overExpirationId
            this.driverExpirationId = res.data.data.driverExpirationId
            this.driverExpirationCount = res.data.data.driverExpirationCount
            this.carAndWeightHis(carCount, onlineCount, offLineCount)
          }
        }
      }).catch(err => { })
    },
    getAlarmCount() {
      this.dayLoading = true
      let collisionCount = ''
      let outPositionCount = ''
      let leaveFenceCount = ''
      let overLoadCount = ''
      let speedOverCount = ''
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomePage/GET_QUERYVIOLATIONCOUNT', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            collisionCount = res.data.data.collisionCount,
              outPositionCount = res.data.data.outPositionCount,
              speedOverCount = res.data.data.speedOverCount,
              leaveFenceCount = res.data.data.leaveFenceCount,
              overLoadCount = res.data.data.overLoadCount
            this.DayUseRate(collisionCount, outPositionCount, speedOverCount, leaveFenceCount, overLoadCount)
          }
        }
        this.dayLoading = false
      }).catch(err => { this.dayLoading = false })
    },
    DayUseRate(collisionCount, outPositionCount, speedOverCount, leaveFenceCount, overLoadCount) {
      let option = {
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisTick: {
            show: false
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#fff',

            }
          },
          data: [this.$t('DriverAnalysis.collisionCount'), this.$t('DriverAnalysis.overloadCount'), this.$t('DriverAnalysis.speedOverCount'), this.$t('DriverAnalysis.outPositionCount'), this.$t('HomPage.leaveFence'),]
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '2%',
          containLabel: true
        },
        yAxis: [{
          name: this.$t('BatteryAnalysis.count'),
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            color: '#fff'
          },
          splitLine: {
            show: true, lineStyle: {
              color: ['rgba(173,177,195,.1)'],
              type: 'dashed'
            }
          },
          min: 0,
        }],
        series: [
          {
            name: this.$t('BatteryAnalysis.count'),
            data: [collisionCount, overLoadCount, speedOverCount, outPositionCount, leaveFenceCount],
            type: 'bar',
            barCategoryGap: '40%',
            barWidth: '18px',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    { offset: 0, color: '#157ede' },
                    { offset: 1, color: '#15a5dd' },
                  ]
                )
              },
            }
          },
        ]
      }
      this.dayOption = option
    },
    getProblemCount() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomePage/GET_QUERYPROBLEMCOUNT', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.problem = {
              FilterPluggingCount: res.data.data.FilterPluggingCount,
              LowOilPressureCount: res.data.data.LowOilPressureCount,
              LowPowerCount: res.data.data.LowPowerCount,
              LowLiquidLevelCount: res.data.data.LowLiquidLevelCount
            }
          }
        }
      }).catch(err => { })
    },
    getData() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomePage/GET_QUERYCARDATA', param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            this.carOptions = res.data.data
            this.map = new BMapGL.Map(this.$refs.allmap);
            var arr = [];
            res.data.data.map((item) => {
              var point = new BMapGL.Point(item.longitude, item.latitude);
              arr.push(point);
            });
            this.view = this.map.getViewport(eval(arr));
            this.mapZoom = this.view.zoom;
            this.centerPoint = this.view.center;
            this.map.centerAndZoom(this.centerPoint, this.mapZoom);
            this.initMap()
          }
        }
      }).catch(err => { })
    },
    initMap() {
      this.map = new BMapGL.Map(this.$refs.allmap);
      this.map.setMapStyleV2({
        styleId: 'de473f98c1e9816993b6c94fe603b871'
      });
      this.map.centerAndZoom(this.centerPoint, this.mapZoom);
      this.map.addControl(new BMapGL.MapTypeControl({
        mapTypes: [
          BMAP_NORMAL_MAP,
          BMAP_HYBRID_MAP
        ]
      }));
      this.map.enableScrollWheelZoom(true);
      var imgOnPic = new Image()
      imgOnPic.src = imgOn
      this.carOptions.map((item, index) => {
        var icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(25, 32), {
          anchor: new BMapGL.Size(10, 30)
        });
        var points = new BMapGL.Point(item.longitude, item.latitude);
        var markers = new BMapGL.Marker(points, { icon: icon });
        this.map.addOverlay(markers);
        this.openInfo(markers, points, item)
      })

    },
    openInfo(markers, points, item) {
      var opts = {
        width: 250,
        height: 300,
      };
      var infoWindow = new BMapGL.InfoWindow(
        this.$t('common.carId') + ':' + item.carId + "<br />" +
        this.$t('common.manufactureNum') + ':' + item.manufactureNum + "<br />" +
        this.$t('common.terminalId') + ':' + item.terminalId + "<br />" +
        this.$t('common.orgName') + ':' + item.orgName + "<br />" +
        this.$t('common.messageTime') + ':' + item.messageTime + "<br />" +
        this.$t('common.province') + ':' + item.province + "<br />" +
        this.$t('common.city') + ':' + item.city + "<br />" +
        this.$t('common.address') + ':' + item.address + "<br />",
        opts
      );
      markers.addEventListener('click', function () {
        this.map.openInfoWindow(infoWindow, points);
      });
    },
    getCarWorkTime() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        pageNum: 1,
        pageSize: 10
      }
      this.$store.dispatch('HomePage/GET_QUERYCARDATALIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
          }
        }
      }).catch(err => { })
    },
    getDriverWorkTime() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        pageNum: 1,
        pageSize: 10
      }
      this.$store.dispatch('HomePage/GET_QUERYDRIVERDATALIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.driveList = res.data.data.list
          }
        }
      }).catch(err => { })
    },
  },
};
